<script setup lang="ts">
import { ageText, type CharacterData } from '../familytree/familytree'
import { alignments } from '../statblock/statblock'
import { titleCase } from '../util'

const page = useDocument()

const character = page.value as CharacterData

const raceText = computed(() => titleCase(character.subrace, character.race))
const age = computed(() => ageText(character))
const alignmentText = computed(() => titleCase(alignments[character.alignment!] ?? character.alignment))
</script>

<template>
  <Factbox ornament-bottom class="character-factbox">
    <slot />
    <h3 v-if="page.name || page.title">{{ page.name || page.title }}</h3>
    <table>
      <tbody>
        <tr v-if="raceText">
          <td><strong>Race</strong></td>
          <td><WikiLink :wiki="raceText" optional /></td>
        </tr>
        <tr v-if="page.class || page.subclass">
          <td><strong>Class</strong></td>
          <td>
            <WikiLink v-if="character.subclass" :wiki="titleCase(character.subclass)" optional class="space-after" />
            <WikiLink v-if="character.class" :wiki="titleCase(character.class)" optional />
          </td>
        </tr>
        <tr v-if="character.background">
          <td><strong>Background</strong></td>
          <td><WikiLink :wiki="titleCase(page.background)" optional /></td>
        </tr>
        <tr v-if="character.alignment">
          <td><strong>Alignment</strong></td>
          <td>{{ alignmentText }}</td>
        </tr>
        <tr v-if="age">
          <td><strong>Age</strong></td>
          <td>{{ age }}</td>
        </tr>
      </tbody>
    </table>
  </Factbox>
</template>

<style scoped lang="postcss"></style>
